/*
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-25 17:10:23
 * @LastEditors: geory
 * @LastEditTime: 2024-04-03 16:55:31
 */
import httpRequest from './request';

const http = {

    //手机号码登录
    getLoginCode (data) {
        return httpRequest.post('/group/web/user/login.do', data,{isUnEncrypt:true});
    },
    //发送验证码
    sendMegCode (data) {
        return httpRequest.post('/group/web/user/sendSms.do', data,{isUnEncrypt:true});
    },
    //查询二维码
    createQrCode (data) {
        return httpRequest.post('/group/web/user/queryQrCode.do', data,{isUnEncrypt:true});
    },
    //二维码登录
    loginByCode (data) {
        return httpRequest.post('/group/web/user/loginByQrCode.do', data,{isUnEncrypt:true});
    },
    //查询话术列表
    qryHuashuTeamList (data) {
        return httpRequest.post('/group/web/shareSpeech/queryList.do', data);
    },
    //查询话术分类列表
    qryHuashuTypeList(data) {
        return httpRequest.post('/group/web/shareSpeech/label/queryList.do', data);
    },
    //查询话术文本列表
    qryHuashuList(data) {
        return httpRequest.post('/group/web/shareSpeech/text/queryList.do', data);
    },
    //话术分类 保存
    huashuTypeSave(data) {
        return httpRequest.post('/group/web/shareSpeech/label/save.do', data);
    },
    //话术文本 保存
    huashuSave(data) {
        return httpRequest.post('/group/web/shareSpeech/text/save.do', data);
    },
    //话术文本 删除
    huashuRemove(data) {
        return httpRequest.post('/group/web/shareSpeech/text/del.do', data);
    },
    //获取 上传token
    getFileUploadToken(data) {
        return httpRequest.post('/group/web/qiniu/getUpLoadKey.do', data,{isUnEncrypt:true});
    },
    //话术多媒体 查询限制
    qryHuashuLimit(data) {
        return httpRequest.post('/group/web/shareSpeech/media/queryLimit.do', data);
    },
    //话术多媒体 提交映射
    submitHuashuMapping(data) {
        return httpRequest.post('/group/web/shareSpeech/media/submitMapping.do', data);
    },
    //话术多媒体 查询标题
    qryHuashuListTitle(data) {
        return httpRequest.post('/group/web/shareSpeech/media/queryFileTitle.do', data);
    },
    //话术多媒体 获取小程序码
    huashuGetMiniCode(data) {
        return httpRequest.post('/group/web/shareSpeech/media/queryMiniProgramCode.do', data);
    },
    //话术文本 搜索
    huashuSearch(data) {
        return httpRequest.post('/group/web/shareSpeech/text/search.do', data);
    },
    //文案包 切换检查
    checkChangeWenanPackage(data) {
        return httpRequest.post('/group/web/text/library/theme/checkTheme.do', data);
    },
    //文案包 我的列表
    wenanPackageList(data) {
        return httpRequest.post('/group/web/text/library/theme/queryMyList.do', data);
    },
    //文案包分类 列表
    wenanCategoryList(data) {
        return httpRequest.post('/group/web/text/library/label/queryList.do', data);
    },
    //文案包文案 列表
    wenanList(data) {
        return httpRequest.post('/group/web/text/library/queryList.do', data);
    },
    //文案包 查询默认
    defaultWenanPackageList(data) {
        return httpRequest.post('/group/web/text/library/theme/queryDefault.do', data);
    },
    //话术分类 批量保存
    huashuTypeBatSave(data) {
        return httpRequest.post('/group/web/shareSpeech/label/batchSave.do', data);
    },
    //话术文本 批量保存
    huashuBatSave(data) {
        return httpRequest.post('/group/web/shareSpeech/text/batchSave.do', data);
    },
};

export default http;
